var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from "@rebass/grid";
// @ts-ignore
import ObjectField from "react-jsonschema-form/lib/components/fields/ObjectField";
// @ts-ignore
import { retrieveSchema } from "react-jsonschema-form/lib/utils";
var FormGrid = /** @class */ (function (_super) {
    __extends(FormGrid, _super);
    function FormGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderRow = function (gridSchema) {
            var rows = gridSchema["row"];
            return (_jsx(Flex, { flexWrap: "wrap", ml: "-12px", children: _this.renderChildren(rows) }));
        };
        _this.renderCol = function (gridSchema) {
            var _a = gridSchema["col"], children = _a.children, colProps = __rest(_a, ["children"]);
            return (_jsx(Box, __assign({ Reflex: true, pl: "12px" }, colProps, { children: _this.renderChildren(children) })));
        };
        _this.renderChildren = function (childrenGridSchema) {
            // @ts-ignore
            var _a = _this.props, registry = _a.registry, schema = _a.schema;
            var definitions = registry.definitions;
            var newSchema = retrieveSchema(schema, definitions);
            return childrenGridSchema.map(function (gridSchema, index) { return (
            // @ts-ignore
            _createElement(FormGrid
            // @ts-ignore
            , __assign({}, _this.props, { key: index, schema: newSchema, gridSchema: gridSchema }))); });
        };
        _this.renderField = function (gridSchema) {
            var _a = _this.props, uiSchema = _a.uiSchema, errorSchema = _a.errorSchema, idSchema = _a.idSchema, disabled = _a.disabled, readonly = _a.readonly, onBlur = _a.onBlur, onFocus = _a.onFocus, formData = _a.formData, registry = _a.registry, schema = _a.schema;
            var definitions = registry.definitions, fields = registry.fields;
            var SchemaField = fields.SchemaField;
            var newSchema = retrieveSchema(schema, definitions);
            var name;
            var render;
            if (typeof gridSchema === "string") {
                name = gridSchema;
            }
            else {
                (name = gridSchema.name);
                (render = gridSchema.render);
            }
            // @ts-ignore
            if (schema.properties[name]) {
                return (_jsx(SchemaField, { name: name, 
                    // @ts-ignore
                    required: _this.isRequired(name), 
                    // @ts-ignore
                    schema: newSchema.properties[name], uiSchema: uiSchema[name], errorSchema: errorSchema[name], idSchema: idSchema[name], formData: formData[name], 
                    // @ts-ignore
                    onChange: _this.onPropertyChange(name), onBlur: onBlur, onFocus: onFocus, 
                    // @ts-ignore
                    registry: _this.props.registry, disabled: disabled, readonly: readonly }, name));
            }
            var UIComponent = render || (function () { return null; });
            return (_jsx(UIComponent, { name: name, formData: formData, errorSchema: errorSchema, uiSchema: uiSchema, schema: schema, 
                // @ts-ignore
                registry: _this.props.registry }, name));
        };
        return _this;
    }
    // Render
    FormGrid.prototype.render = function () {
        // @ts-ignore
        var _a = this.props, uiSchema = _a.uiSchema, _b = _a.gridSchema, gridSchema = _b === void 0 ? uiSchema["grid"] : _b;
        if (!gridSchema) {
            return null;
        }
        if (gridSchema["row"]) {
            return this.renderRow(gridSchema);
        }
        if (gridSchema["col"]) {
            return this.renderCol(gridSchema);
        }
        return this.renderField(gridSchema);
    };
    return FormGrid;
}(ObjectField));
// eslint-disable-next-line import/no-default-export
export default FormGrid;
